// extracted by mini-css-extract-plugin
export default {"root":"Tag_root__2DHJi","primary":"Tag_primary__N15-A","secondary":"Tag_secondary__SZhb-","tertiary":"Tag_tertiary__-+rRE"};